import { Component, ComponentPublicInstance, DirectiveBinding, h, ObjectDirective, render } from "vue";

export const useDirectiveComponent = <ComponentProps extends Record<string, unknown>>(
  component: Component,
  props: (binding: DirectiveBinding, el: HTMLElement) => ComponentProps | null
): ObjectDirective => {
  const hook = mountComponent(component, props);

  return {
    mounted: hook,
    updated: hook,
    unmounted: (el: HTMLElement) => render(null, el),
  };
};

const mountComponent = (
  component: Component,
  propsBuilder: (binding: DirectiveBinding, el: HTMLElement) => Record<string, unknown> | null
) => {
  return (el: HTMLElement, binding: DirectiveBinding) => {
    const builtProps = propsBuilder(binding, el);

    if (builtProps === null) {
      render(null, el);
      return;
    }

    const instance = binding.instance as ComponentPublicInstance;
    const node = h(component, builtProps);

    if (instance?.$.appContext) {
      node.appContext = {
        ...instance.$.appContext,
        provides: {
          ...(instance.$.appContext.provides ?? {}),
        },
      };
    }

    render(node, el);
  };
};
